export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/masterExcelWorker.8ac415a1.worker.js");
}
